import { default as MuiSkeleton, SkeletonProps } from '@mui/material/Skeleton'
import * as React from 'react'

export const Skeleton: React.FC<React.PropsWithChildren<SkeletonProps>> = (props) => {
  return <MuiSkeleton {...props} />
}

export default Skeleton
